import { supabase } from '../lib/supabase';

// Normalize error to always be a proper Error instance
function normalizeError(err, fallback) {
  if (err instanceof Error) return err;
  if (err && typeof err === 'object') {
    const msg = err?.message || fallback || 'Unknown error';
    return Object.assign(new Error(msg), err);
  }
  return new Error(err || fallback || 'Unknown error');
}

export const mobileConfigService = {
  async getConfig(platform, configKey) {
    const { data, error } = await supabase?.from('mobile_config')?.select('*')?.eq('platform', platform)?.eq('config_key', configKey)?.maybeSingle();

    if (error) {
      console.error('Error fetching mobile config:', error?.message);
      return null;
    }
    return data;
  },

  async getAllConfigs() {
    const { data, error } = await supabase?.from('mobile_config')?.select('*')?.order('platform')?.order('config_key');

    if (error) {
      console.error('Error fetching all mobile configs:', error?.message);
      return [];
    }
    return data || [];
  },

  async upsertConfig(platform, configKey, configValue, updatedBy) {
    const { data, error } = await supabase?.from('mobile_config')?.upsert(
        {
          platform,
          config_key: configKey,
          config_value: configValue,
          updated_by: updatedBy,
          updated_at: new Date()?.toISOString()
        },
        { onConflict: 'platform,config_key' }
      )?.select()?.single();

    if (error) {
      console.error('Error upserting mobile config:', error?.message);
      throw normalizeError(error, 'Error upserting mobile config');
    }
    return data;
  },

  async getScreenVisibility(platform) {
    const config = await this.getConfig(platform, 'screen_visibility');
    return config?.config_value || {};
  },

  async updateScreenVisibility(platform, visibility, updatedBy) {
    return this.upsertConfig(platform, 'screen_visibility', visibility, updatedBy);
  },

  async getPwaSettings() {
    const config = await this.getConfig('global', 'pwa_settings');
    return config?.config_value || {};
  },

  async updatePwaSettings(settings, updatedBy) {
    return this.upsertConfig('global', 'pwa_settings', settings, updatedBy);
  },

  async getPlatformSettings(platform) {
    const config = await this.getConfig(platform, 'platform_settings');
    return config?.config_value || {};
  },

  async updatePlatformSettings(platform, settings, updatedBy) {
    return this.upsertConfig(platform, 'platform_settings', settings, updatedBy);
  }
};

export default mobileConfigService;
